export default "__VITE_ASSET__DB$_dP3T__"